import React, { useEffect, useState } from 'react';
import { TextField, FormControl, InputLabel, Grid, Paper, Select, MenuItem, useMediaQuery, Button, FormHelperText } from '@mui/material';
import styled, { inputImages, inputStyles } from '../../Utils/inputChanges';
import Titlebar from '../TitleBar';
import { Cloth } from '../TitleList';
import { useDispatch, useSelector } from 'react-redux';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import { errorStyles } from '../../Utils/table';
import { fetchPannaData } from '../../Store/PHPSlice/Panna';
import { createClothEntry } from '../../Store/PHPSlice/Cloth';
import DropdownWithBtn from '../FieldsComponents/DropdownWithBtn';


const ClothEntry = () => {
    const userdata = JSON.parse(sessionStorage.getItem('user'));
    const [formData, setFormData] = useState({
        cloth: '',
        model: '',
        color: '',
        shade: '',
        panna: '',
        hsn: '',
        rate: '',
        clothImg: '',
        uom: 'm',
        userId: userdata?.ID
    });
    const [errors, setErrors] = useState({});

    const [openDropdowns, setOpenDropdowns] = useState({});
    const actionMap = {
        panna: fetchPannaData
        // Add more mappings if needed
    };

    const isDesktop = useMediaQuery('(min-width:768px)'); // Adjust the breakpoint as per your requirement
    const dispatch = useDispatch();
    const getPanas = useSelector((state) => state.PannaData.pana || { data: [] });
    useEffect(() => {
        dispatch(fetchPannaData());
        Object.keys(openDropdowns).forEach((dropdown) => {
            if (openDropdowns[dropdown]) {
                const action = actionMap[dropdown];
                if (action) {
                    dispatch(action());
                }
            }
        });
    }, [openDropdowns, dispatch]);

    if (!getPanas) {
        return <h1>Loading...</h1>
    }
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value.toUpperCase()
        });
    };
    const handleImageChange = (e) => {
        setFormData({
            ...formData,
            clothImg: e.target.files[0]
        });
    };
    const handleDropdownChange = (e, dropdownType) => {
        const { value } = e.target;
        setFormData({
            ...formData,
            [dropdownType]: value
        });
    };


    const handleDropdownOpen = (dropdown) => {
        setOpenDropdowns((prev) => ({ ...prev, [dropdown]: true }));
    };

    const handleDropdownClose = (dropdown) => {
        setOpenDropdowns((prev) => ({ ...prev, [dropdown]: false }));
    };

    const validate = () => {
        const newErrors = {};
        if (!formData.cloth) newErrors.cloth = 'Cloth is required';
        // if (!formData.model) newErrors.model = 'Model is required';
        if (!formData.color) newErrors.color = 'Color is required';
        // if (!formData.shade) newErrors.shade = 'Shade No is required';
        if (!formData.panna) newErrors.panna = 'Panna is required';
        // if (!formData.hsn) newErrors.hsn = 'HSN is required';
        return newErrors;
    };


    const handleSubmit = (e) => {
        e.preventDefault();
        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        const formDataToSend = new FormData();
        formDataToSend.append('cloth', formData.cloth);
        formDataToSend.append('model', formData.model);
        formDataToSend.append('color', formData.color);
        formDataToSend.append('shade', formData.shade);
        formDataToSend.append('panna', formData.panna);
        formDataToSend.append('hsn', formData.hsn);
        formDataToSend.append('rate', formData.rate);
        formDataToSend.append('uom', formData.uom);
        formDataToSend.append('userId', formData.userId);

        if (formData.clothImg instanceof File) {
            formDataToSend.append('image', formData.clothImg);
        }


        dispatch(createClothEntry(formDataToSend))
            .unwrap()
            .then((result) => {
                // Handle success
                console.log('POST request successful!', result);
                // toast.success("Cloth Added");
                alert("Cloth Added");
                window.location.reload();
                // You may want to update your component state or perform any other action
            })
            .catch((error) => {
                // Handle error
                console.error('Error while making POST request:', error);
                // You may want to display an error message to the user or perform any other action
            });

    };

    const handleNavigatePanna = () => {
        window.open(`/new-panna-entry`, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');
    };

    const dropdownPanna = [
        {
            label: 'Panna',
            id: 'panna',
            options: getPanas?.data || [],
            value: formData.panna,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'panna', value: newValue ? newValue.panna_size : '' } }, 'panna'),
            getOptionLabel: (option) => option.panna_size || '',
            isOptionEqualToValue: (option, value) => option.panna_size === value.panna_size,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.panna_size === value) || null;
                }
                return null;
            },
            handleAddNew: () => handleNavigatePanna(),
            btnlabel: 'New',
            handleDropdownOpen: () => handleDropdownOpen('panna'),
            handleDropdownClose: () => handleDropdownClose('panna'),
        }
    ];


    return (
        <>

            <Titlebar data={Cloth} />
            <div style={{ margin: '1% 0.5%' }}>
                <h2>Cloth Entry</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '2vh' }}>
                            <Grid container spacing={0.5}>
                                {[
                                    { label: 'Cloth', name: 'cloth' },
                                    { label: 'Model', name: 'model' },
                                    { label: 'Color', name: 'color' },
                                    { label: 'Shade No', name: 'shade' },
                                    { label: 'HSN', name: 'hsn' }
                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name} >{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth error={!!errors[field.name]}>
                                                    {field.type === 'file' ? (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            type="file"
                                                            onChange={handleImageChange}
                                                            inputProps={{ style: styled.inputImg }}
                                                            sx={inputImages}
                                                        />
                                                    ) : (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            value={formData[field.name]}
                                                            onChange={handleInputChange}
                                                            inputProps={{ style: styled.input }}
                                                            sx={inputStyles}
                                                        />
                                                    )}
                                                    {errors[field.name] && <FormHelperText style={errorStyles}>{errors[field.name]}</FormHelperText>}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}

                                {/* Panna dropdown */}

                                {/* <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel id="panna">Panna :</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth error={!!errors.panna}>
                                                <Select
                                                    labelId="panna"
                                                    id="panna"
                                                    name="panna"
                                                    value={formData.panna}
                                                    onChange={(e) => handleDropdownChange(e, 'panna')}
                                                    sx={inputStyles}
                                                >
                                                    <MenuItem value="">Select an option</MenuItem>
                                                    {
                                                        getPanas?.data?.map((item, index) => (
                                                            <MenuItem key={index} value={item.panna_size}>{item.panna_size}</MenuItem>
                                                        ))
                                                    }
                                                </Select>
                                                {errors.panna && <FormHelperText style={errorStyles}>{errors.panna}</FormHelperText>}
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid> */}

                                {dropdownPanna?.map((drop) => (
                                    <DropdownWithBtn 
                                        key={drop.label}
                                        label={drop.label}
                                        id={drop.id}
                                        options={drop.options}
                                        value={drop.value}
                                        onChange={drop.onChange}
                                        isDesktop={isDesktop}
                                        getOptionLabel={drop.getOptionLabel}
                                        isOptionEqualToValue={drop.isOptionEqualToValue}
                                        valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                        handleAddNew={drop.handleAddNew}
                                        btnlabel={drop.btnlabel}
                                        handleDropdownOpen={drop.handleDropdownOpen}
                                        handleDropdownClose={drop.handleDropdownClose}
                                    />
                                ))
                                }


                                {[

                                    { label: 'Rate', name: 'rate' },
                                    { label: 'UOM', name: 'uom' },
                                    { label: 'Cloth Image', name: 'clothImg', type: 'file' },


                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name} >{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth error={!!errors[field.name]}>
                                                    {field.type === 'file' ? (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            type="file"
                                                            onChange={handleImageChange}
                                                            inputProps={{ style: styled.inputImg }}
                                                            sx={inputImages}
                                                        />
                                                    ) : (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            value={formData[field.name]}
                                                            onChange={handleInputChange}
                                                            inputProps={{ style: styled.input }}
                                                            sx={inputStyles}
                                                            InputProps={field.name === 'uom' ? { readOnly: true } : {}}
                                                        />
                                                    )}
                                                    {errors[field.name] && <FormHelperText style={errorStyles}>{errors[field.name]}</FormHelperText>}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}

                                <Grid item xs={12} textAlign="center">
                                    <Button variant="contained" color="primary" onClick={handleSubmit} >Submit</Button>
                                </Grid>
                            </Grid>
                            <ToastContainer />
                        </Paper>
                    </Grid>
                </Grid>
            </div>
        </>
    );
}

export default ClothEntry;